/**
 *
 * History file
 * Reports Frontend
 * 
 */

import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();